import Vue from 'vue';
import { AclInstaller, AclCreate, AclRule } from 'vue-acl';
import router from '@/router';

Vue.use(AclInstaller);

let initialRole = 'guest',
  notfoundPage = '/404';

const exp = localStorage.getItem('expires_at');

if (exp) {
  const now = Date.now() / 1000;
  if (parseInt(exp) > now) {
    // change below line when user roles exist
    initialRole = 'admin';
    notfoundPage = '/';
  } else {
    localStorage.clear();
  }
}

export default new AclCreate({
  initial: initialRole,
  notfound: notfoundPage,
  router,
  acceptLocalRules: true,
  globalRules: {
    any: ['*'],
    public: new AclRule('public').generate(),
    admin: new AclRule('rAdmin').generate(),
    business: new AclRule('rBusiness').generate(),
    candidate: new AclRule('rCandidate').generate(),
    adminOrBusiness: new AclRule('rBusiness').or('rAdmin').generate(),
    loggedIn: new AclRule('rCandidate')
      .or('rBusiness')
      .or('rAdmin')
      .or('rNoActiveRole')
      .generate(),
    guest: new AclRule('guest').generate(),
    test: new AclRule('user')
      .and('rBusiness')
      .or('rAdmin')
      .and('rCandidate')
      .generate(),
    serviceCandidateProcess: new AclRule('kAssessorResponseProcess')
      .and('rAdmin')
      .or('kDoctorSignoffProcess')
      .and('rAdmin')
      .generate(),
    allowTopUp: new AclRule('kPaymentTopUp').and('rAdmin').generate(),
    allowRiskProfileTemplateCRUD: new AclRule('kRiskProfileTemplateRead')
      .and('kRiskProfileTemplateCreate')
      .and('kRiskProfileTemplateUpdate')
      .and('kRiskProfileTemplateDelete')
      .and('rAdmin')
      .generate(),
    allowRiskProfileTemplateRead: new AclRule('kRiskProfileTemplateRead')
      .and('rAdmin')
      .generate(),
    allowRiskProfileTemplateCreate: new AclRule('kRiskProfileTemplateCreate')
      .and('rAdmin')
      .generate(),
    allowOAuthCRUD: new AclRule('kBusinessOAuthRead')
      .and('kBusinessOAuthCreate')
      .and('kBusinessOAuthUpdate')
      .and('kBusinessOAuthDelete')
      .and('rAdmin')
      .generate(),
    allowQuestionGroupCRUD: new AclRule('kQuestionGroupRead')
      .and('kQuestionGroupCreate')
      .and('kQuestionGroupUpdate')
      .and('kQuestionGroupDelete')
      .and('rAdmin')
      .generate(),
    allowQuestionGroupREAD: new AclRule('kQuestionGroupRead')
      .and('rAdmin')
      .generate(),
    allowQuestionGroupCREATE: new AclRule('kQuestionGroupCreate')
      .and('rAdmin')
      .generate(),
    allowPrivilegeCRUD: new AclRule('kUserPrivilegeRead')
      .and('kUserPrivilegeCreate')
      .and('kUserPrivilegeUpdate')
      .and('kUserPrivilegeDelete')
      .generate(),
  },
});
